import { all, call, fork, put, takeLeading } from "typed-redux-saga";
import { Action, filterActions } from "./filter-store";
import { errorActions } from "src/components/error-viewer/error-store";
import { ConfiguratorService } from "src/backend/openapi/v1";
import { getContactPerson, getCurrentCustomer } from "src/utils";

export function* getFilters(action: ReturnType<typeof filterActions.getFiltersRequest>) {
  try {
    const contactPerson = yield* getContactPerson();
    const customer = yield* getCurrentCustomer();
    if (!contactPerson.identityId) throw Error("Missing identity id");

    const result = yield* call(ConfiguratorService.getApiV1ConfiguratorConfigurationsFilter, action.payload.projectId, contactPerson.identityId, customer.customerId);
    yield put(filterActions.getFiltersSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(filterActions.getFiltersFail());
  }
}

export function* watchGetFilters() {
  yield takeLeading(Action.GetFiltersRequest, getFilters);
}

export function* filterSaga() {
  yield all([fork(watchGetFilters)]);
}
